export * from './types';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-core/esm/domain/deflate/index.js
// module id = 1181
// module chunks = 0